import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { comisionesModulo } from '../diccionarios/comisionesModulo';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AsignacionesService {

  diccionarioUrl: any;
  urlMaestros: string;
  urlComisiones: string;
  diccionarioUrlMaestros:string;

  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
  ) {
    this.urlMaestros = this.utilServices.getDatosMaestros();
    this.urlComisiones = this.utilServices.getComisiones();
    this.diccionarioUrl = comisionesModulo.url.asignaciones;
    this.diccionarioUrlMaestros = comisionesModulo.url.maestros;
  }

  getTodo() {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerTodo);
  }

  getPorId(id: string) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerPorId + id);
  }

  getPorIdDetalle(id: string) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerPorIdDetalle + id);
  }

  getPorVendedorId(id: string) {
    return this.commom.peticionGetConHeader(this.urlMaestros + this.diccionarioUrl.maestros.getVendedor + id);
  }

  getTiposDeVendedoresGrid(id: string) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerPorTiposDeVendedoresGrid + id);
  }

  getSubDistribuciones(asignacionId, variableId) {
    return this.commom.peticionGetConHeader(this.urlComisiones + this.diccionarioUrl.obtenerSubDistribuciones + asignacionId + '/variable/' + variableId);
  }

  save(innObj: any) {
    console.log("saveTipoDeVendedore", innObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.crear, innObj);
  }

  saveDetalle(innObj: any) {
    console.log("saveTipoDeVendedore", innObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.crearDetalle, innObj);
  }

  update(innObj: any) {
    console.log("updateTipoDeVendedore", innObj)
    return this.commom.peticionPutConHeader(this.urlComisiones + this.diccionarioUrl.actualizar, innObj);
  }

  delete(innIdDireccion: string) {
    return this.commom.peticionDeleteConHeader(this.urlComisiones + this.diccionarioUrl.eliminar+ `${innIdDireccion}`);
  }
  
  procesarCsv(formData: FormData): Observable<any[]> {
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.recepcionCsv, formData);
  }

  saveCsv(listObj: any[]) { //
    console.log("saveCsvIndicadores", listObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.recepcionCsvSave , listObj);
  }

  getVededor(idVendedor) {
    return this.commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioUrl.getVendedor + idVendedor
    );
  }

  getMacroCategoria() {
    return this.commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioUrl.maestros.getMacroCategorias
    );
  }

  getLineas(macroCategoria) {
    return this.commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioUrl.maestros.getLineas + macroCategoria
    );
  }

  getCategorias(linea) {
    return this.commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioUrl.maestros.getCategorias + linea
    );
  }

  getSubCategorias(categoria) {
    return this.commom.peticionGetConHeader(
      this.urlMaestros + this.diccionarioUrl.maestros.getSubCategorias + categoria
    );
  }

  saveSubCategorias(innObj: any) {
    console.log("saveTipoDeVendedore", innObj)
    return this.commom.peticionPostConHeader(this.urlComisiones + this.diccionarioUrl.crearSubDistribuciones, innObj);
  }

}
